/* eslint-disable react/jsx-props-no-spreading, react/prop-types */
import classnames from 'classnames';
import { colord } from "colord";

// below here for testing imports
import { PanelBody,RangeControl,SelectControl } from '@wordpress/components';

const { assign, merge } = lodash;
const { __ } = wp.i18n;




const MaskPanel = (myprops) => {

// Need to understand what I am passing here
	const props = myprops.props
	const {attributes,setAttributes} = props;
	const {aplomask,aploclip} = props.attributes;


	const maskSelect = () => {
		if (typeof aplomask === 'undefined') {
			return
		}

		
		return (
		<>
		<p>{__('Set a polygon based mask and then adjust the settings of the mask using the clip value','aploblocks')}</p>
		<SelectControl
		label={__('Polygon Mask', 'aploblocks')}
		labelPosition='left'
		value={aplomask}
		options={[
				 {label:__('<none>','aploblocks'),value: ''},
				 {label:__('Point Right', 'aploblocks'),value: 'pr'},
				 {label:__('Point Left', 'aploblocks'),value: 'pl'},
				 {label:__('Point Left&Right', 'aploblocks'),value: 'plr'},
				 {label:__('Lean Right', 'aploblocks'),value: 'sr'},
				 {label:__('Lean Left', 'aploblocks'),value: 'sl'},
				 {label:__('Slope Up', 'aploblocks'),value: 'su'},
				 {label:__('Slope Down', 'aploblocks'),value: 'sd'},
				 {label:__('Slope Up Bottom', 'aploblocks'),value: 'sub'},
				 {label:__('Slope Down Bottom', 'aploblocks'),value: 'sdb'},
				 {label:__('Slope Up Top', 'aploblocks'),value: 'sut'},
				 {label:__('Slope Down Top', 'aploblocks'),value: 'sdt'},
				 {label:__('Pinch Left&Right', 'aploblocks'),value: 'pilr'},
				 {label:__('Pinch Top&Bottom', 'aploblocks'),value: 'pitb'},

				 /*{label:__('Circle', 'aplomask'),value: 'c'},
				 {label:__('Ellipse', 'aplomask'),value: 'e'},
				 {label:__('Curve on Right', 'aplomask'),value: 'cr'},
				 {label:__('Curve on Left', 'aplomask'),value: 'cl'},
				 {label:__('Wave Bottom', 'aplomask'),value: 'wb'},
				 {label:__('Wave Top', 'aplomask'),value: 'wt'},
				 {label:__('Wave All Around', 'aplomask'),value: 'wa'},
				 {label:__('Wave All Around Two', 'aplomask'),value: 'wa2'},
				 {label:__('Circle Right', 'aplomask'),value: 'cir'},*/
			]}
		onChange={(value) => {
			setAttributes({ aplomask: value });
		}} 
	/></>)
	}	

	return (

		<PanelBody title={__('Aplo Mask Style', 'aploblocks')} initialOpen={false} className="aplogeneralstyles">

						{typeof maskSelect !== 'undefined' ?	maskSelect() : ''}

						<RangeControl
							label={__('Clip value','aploblocks')}
							value={ aploclip }
							onChange={(value) => {
								setAttributes({aploclip: value});
							}}
							min={ 1 }
							max={ 50 }
							step={1}
							allowReset={true}
						/>
	
						
				</PanelBody>


	)




}



export default MaskPanel